module.exports = __webpack_public_path__ + "privateAssetLabSlideoutAsset.42c9c448d8c75222c7e7973777fdb6e7.png";